import { BaseFieldProps, InputField } from "./InputField";
import { constants } from "../../../constants/constants";
import { DayPickerInput } from "../../controls/DayPickerInput";
import moment from "moment";
import classNames from "classnames";

interface DateFieldProps extends BaseFieldProps {
    placeholder?: string;
    maximumDate?: Date;
    emptyIfNull?: boolean;
    dateFormat?: string;
    dateInputFormat?: string[];
    withCustomView?: boolean;
    disabled?: boolean;
    showErrorWhenUntouched?: boolean;
}

export const DateField = ({
    placeholder = "MM/DD/YYYY",
    maximumDate,
    emptyIfNull,
    dateFormat = constants.dateShortFormat,
    dateInputFormat = [constants.dateShortFormat, constants.dateFormat, constants.dateFormat5],
    withCustomView,
    disabled,
    showErrorWhenUntouched = false,
    ...props
}: DateFieldProps) => {
    return (
        <InputField
            {...props}
            renderElement={(formik, field, meta) => {
                const withError = (meta.touched || showErrorWhenUntouched) && meta.error;
                return (
                <div className="data-item-col">
                    <div className="">
                        <DayPickerInput
                            disabled={disabled}
                            selectedDate={field.value ? moment.parseZone(field.value).local(true).toDate() : undefined}
                            placeholder="MM/DD/YYYY"
                            maximumDate={maximumDate}
                            emptyIfNull={emptyIfNull}
                            dateFormat={dateFormat}
                            dateInputFormat={dateInputFormat}
                            onDayChange={(day?: Date | string) => {
                                if (day && moment(day, true).isValid()) {
                                    formik.setFieldValue(
                                        field.name,
                                        moment(day).startOf('day').format(constants.dateTimeFormatUtc)
                                    );
                                } else {
                                    formik.setFieldValue(field.name, day)
                                }
                            }}
                            toMonth={maximumDate}
                            className={classNames("form-control", { "is-invalid": withError })}
                            withCustomView={withCustomView}
                        />
                    </div>
                    {withError && (
                        <div className="form-error">{meta.error}</div>
                    )}
                </div>
                );
            }}
        />
    );
};
